/**
 * 经纪人管理
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { XInput, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import http from '@/assets/api/http';
import model from '@/reducers/user/agent/model';
import { connect } from 'react-redux';
import { message } from 'antd';
import StateUpdateModal from './modal/StateUpdateModal';
import { isOC, isPlat } from '@/assets/js/authType';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import CouponModal from '../modal/CouponModal';

class Main extends React.Component {

    state = {
        openModalType: '',
        openModalParam: {},
        tel: '',  // 手机号码
        realName: '', // 姓名
        status: {}, // 会员状态
        beginOpenTime: undefined, // 注册开始时间
        endOpenTime: undefined, // 注册结束时间
        idCardNo: '', // 身份证号码

        selectedRowKeys: [],
        selectedRows: [],
    };

    componentDidMount() {
        this.props.getAgentState();
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }

    // 表格操作
    _tableAction = (type, record) => {
        const { history } = this.props;
        let disable;
        switch (type) {
            case 'detail':
                history.push({ pathname: '/home/user/agent/detail/' + record.userId });
                break;
            case 'available': // 启用禁用
                disable = record.status == 'DISABLE' || record.status == 'BLACK' ? true : false;
                if (disable) {
                    // 启用
                    http('/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.updateUserBrokerStatus', { userId: record.userId, status: 'ENABLE' }, 'POST').then(() => {
                        message.success('启用成功');
                        this.setState({ openModalType: '', openModalParam: {} }, () => {
                            this._searchHandle('useCache');
                        });
                    }).catch((e) => {
                        message.error(e.message);
                    });
                } else {
                    // 禁用
                    this.setState({ openModalType: 'disable', openModalParam: { userId: record.userId } });
                }
                break;
        }
    }

    // 渲染弹窗
    _renderModal = () => {
        const { openModalType, openModalParam } = this.state;
        switch (openModalType) {
            case 'disable':
                return <StateUpdateModal visible={true} data={openModalParam} closeModal={this._closeModal} />;
            case 'coupon':
                return <CouponModal visible={true} data={openModalParam} closeModal={this._closeModal} />
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (update) => {
        this.setState({ openModalType: '', openModalParam: {} }, () => {
            if (update) {
                this._searchHandle('useCache');
            }
        });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, tel, realName, status, beginOpenTime, endOpenTime } = this.state;
        const query = {
            tel,
            realName,
            status: status.code ? status.code : undefined,
            beginOpenTime,
            endOpenTime,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getAgentList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ tel: '', realName: '', status: {}, beginOpenTime: undefined, endOpenTime: undefined }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    _sendCoupon = () => {
        if (this.state.selectedRowKeys.length === 0) {
            message.warning('请选择要发放的用户');
            return;
        }
        this.setState({ openModalType: 'coupon', openModalParam: { ids: this.state.selectedRowKeys } });
    }

    // 表格复选输入
    _rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({ selectedRowKeys, selectedRows });
        },
    };

    render() {
        const { tel, realName, status, beginOpenTime, endOpenTime } = this.state;
        const { agentList, agentState } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache');
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='手机号码'
                                placeholder='请输入手机号码'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                                maxLength={11}
                                mode='number'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='姓名'
                                placeholder='请输入姓名'
                                value={realName}
                                bindThis={this}
                                bindName='realName'
                                maxLength={56}
                                mode='chiLetNum'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='注册时间'
                                value={beginOpenTime}
                                bindThis={this}
                                bindName='beginOpenTime'
                                showTime={false}
                                defaultTime='00:00:00'
                            />
                            <XDatePicker
                                style={{ marginRight: '20px' }}
                                label=''
                                value={endOpenTime}
                                bindThis={this}
                                bindName='endOpenTime'
                                showTime={false}
                                defaultTime='23:59:59'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='经纪人状态'
                                placeholder='请选择状态'
                                renderData={agentState}
                                dataIndex='value'
                                keyIndex='code'
                                value={status.value}
                                bindThis={this}
                                bindName='status'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.operate_box}>
                        {isPlat() &&
                            <XOKButton
                                style={{ width: '100px', marginRight: 10 }}
                                label='发放卡券'
                                onClick={this._sendCoupon}
                            />
                        }
                        {isOC() &&
                            <XOKButton style={{ width: '110px' }} label='邀请经纪人' onClick={() => {
                                this.props.history.push({ pathname: '/home/user/agent/invite' });
                            }} />
                        }
                    </div>
                    <TableContent
                        rowSelection={this._rowSelection}
                        renderData={agentList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderModal()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object, // 路由
    getAgentList: PropTypes.func,
    agentList: PropTypes.object,
    getAgentState: PropTypes.func,
    agentState: PropTypes.array,
    setBreadcrumbPaths: PropTypes.func,
};

const mapStateToProps = (state) => ({
    agentList: state.agent.getAgentList,
    agentState: state.agent.getAgentState,
});
export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);